import { S } from '@angular/cdk/keycodes';
import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AppService } from 'src/app/services/app/app.service';
import { CommonService } from 'src/app/services/common/common.service';
import { RulesService } from 'src/app/services/rules/rules.service';

@Component({
  selector: 'app-job-scheduling-settings',
  templateUrl: './job-scheduling-settings.component.html',
  styleUrls: ['./job-scheduling-settings.component.scss']
})
export class JobSchedulingSettingsComponent {
  public selectedSetting: any;
  public settingsArr: any[] = [
    { name: "General", icon: "fa-cog", id: 0, u_typ: ['company', 'recruiter'] },
    // { name: "Pay Rates", icon: "fa-cog",id:1, u_typ: ['company', 'recruiter'] },
    { name: "Notifications", icon: "fa-cog", id: 1, u_typ: ['recruiter'] },
    { name: "Limitations", icon: "fa-cog", id: 2, u_typ: ['company', 'recruiter'] },
    // {name:"Team Member",icon:"fa-cog"}, 
    // {name:"Notifications",icon:"fa-cog"}, 
  ]
  public notificationArr: any[] = [
    { name: "A user has confirmed a shift", mobile: 0, email: 0, key_name: "confirmed_shift" },
    { name: "A user has rejected a shift", mobile: 0, email: 0, key_name: "reject_shift" },
    { name: "A user has checked in to a shift", mobile: 0, email: 0, key_name: "clock_in_shift" },
    { name: "A user has completed a shift ", mobile: 0, email: 0, key_name: "clock_out_shift" },
    { name: "A user has claimed/ unclaimed a shift", mobile: 0, email: 0, key_name: "claim_unclaim_shift" },
    { name: "A user requested to claim a shift", mobile: 0, email: 0, key_name: "request_claim_shift" },
    // {name:"A user requested shift replacement",mobile:0,email:0,key_name:"shift_replacement"},
    { name: "A user has completed a task", mobile: 0, email: 0, key_name: "completed_task" },
    { name: "A user has completed all tasks", mobile: 0, email: 0, key_name: "completed_all_task" },
    { name: "A user marked unavailability", mobile: 0, email: 0, key_name: "mark_unavailibility" },
    { name: "A user marked prefers to work", mobile: 0, email: 0, key_name: "prefer_to_work" },
    { name: "A user didn't check into a shift that started", type: "input", mobile: 0, email: 0, value: "", key_name: "not_confirm_before_start" },
    { name: "A user didn't complete a shift that ended", type: "input", mobile: 0, email: 0, value: "", key_name: "not_clockin_shift_time" },
    { name: "A user didn't clock into a shift that started", type: "input", mobile: 0, email: 0, value: "", key_name: "not_clockout_shift_end" },
  ]
  public notificationAdminArr: any[] = [
    { name: "An admin edited shifts status", mobile: 0, email: 0, key_name: "not_clockout_shift_end" },
    { name: "An admin edited shifts status", mobile: 0, email: 0, key_name: "not_clockout_shift_end" },
  ]
  public schedulerLimitationArr: any[] = [
    { name: "Max work hours per user per week", type: "Hours", key_name: "max_hour_week", selected: false, value: "" },
    { name: "Max number of shifts per user per week", type: "Shifts", key_name: "max_shift_week", selected: false, value: "" },
    { name: "Max work hours per user per day", type: "Hours", key_name: "max_hour_day", selected: true, value: "32" },
    { name: "Max number of shifts per user per day", type: "Shifts", key_name: "max_shift_day", selected: false, value: "" },
    { name: "Min hours gap between consecutive shifts", type: "Hours", key_name: "min_gap_shift", selected: false, value: "" },
  ]
  public userLimitationArr: any[] = [
    { name: "Users can't reject a shift less than", af_bf: "1", type: "custom", value: "2", hmd: "1", key_name: "user_cant_reject_specific_time", selected: false },
    { name: "Users can't un-claim a shift less than", type: "custom", af_bf: "1", value: "2", hmd: "2", key_name: "user_cant_unclaim_specific_time", selected: false },
    { name: "Users can only check-in to a shift up to", type: "custom", af_bf: "1", value: "2", hmd: "3", key_name: "user_can_clockin_specific_time_before", selected: false },
    { name: "Block users from claiming shifts if they overlap with a scheduled shift", key_name: "user_block_claim_overlap", selected: false },
    { name: "Users can claim/check-in to shifts past their end time", key_name: "user_claim_clockin_after_shift", selected: false },
  ]
  public notificationObj = {
    "confirmed_shift": [{ "mobile": "1", "push": "", "email": "" }],
    "reject_shift": [{ "mobile": "1", "push": "", "email": "" }],
    "clock_in_shift": [{ "mobile": "1", "push": "", "email": "" }],
    "clock_out_shift": [{ "mobile": "1", "push": "", "email": "" }],
    "claim_unclaim_shift": [{ "mobile": "1", "push": "", "email": "" }],
    "request_claim_shift": [{ "mobile": "1", "push": "", "email": "" }],
    "completed_task": [{ "mobile": "1", "push": "", "email": "" }],
    "completed_all_task": [{ "mobile": "1", "push": "", "email": "" }],
    "mark_unavailibility": [{ "mobile": "1", "push": "", "email": "" }],
    "prefer_to_work": [{ "mobile": "1", "push": "", "email": "" }],
    "not_confirm_before_start": [{ "mobile": "1", "push": "", "email": "", "hmd": "1", "af_bf": "0", "value": "" }],
    "not_clockin_shift_time": [{ "mobile": "1", "push": "", "email": "", "hmd": "1", "af_bf": "0", "value": "" }],
    "not_clockout_shift_end": [{ "mobile": "1", "push": "", "email": "", "hmd": "1", "af_bf": "0", "value": "" }],
    "admin_edited_shift_status": [{ "mobile": "1", "push": "", "email": "" }],
    "admin_edited_shift_notes": [{ "mobile": "1", "push": "", "email": "" }],
  }
  public generalObj = {
    "enable_unavailability": { "selected": false },
    "unavailability_val": "",
    "enable_shift_replacement": { "selected": false },
    "shift_replacement": { "yes_no": "1", "selected": false },
    "replacement_app": { "selected": false },
    "reject_button": { "yes_no": "1" },
    "confirm_button": { "yes_no": "1" },
    "clock_in_button": { "yes_no": "1" },
    "clock_out_button": { "yes_no": "1" },
    "gps_enable": { "yes_no": "1" },
    "created_shift": false,
    "publish_shift": false,
    "assign_shift": false,
    "who_created_shift": { "yes_no": "0", "selected": false },
    "who_assign_shift": { "yes_no": "0", "selected": false },
    "who_publish_shift": { "yes_no": "0", "selected": false },
    "user_mark_unavailability": { "yes_no": "0", "selected": false },
    "user_mark_prefer_unavailability": { "yes_no": "0", "selected": false },

  }
  public durationArr: any[] = [
    { key: "Days", val: "day", value: "3" },
    { key: "Hours", val: "week", value: "1" },
    { key: "Minutes", val: "day", value: "2" },
  ]

  constructor(private dialogRef: MatDialogRef<JobSchedulingSettingsComponent>, private rulesService: RulesService, private commonService: CommonService,
    private appService: AppService,) { }

  ngOnInit(): void {
    this.selectedSetting = this.settingsArr[0];
    this.getSettings()
  }
  onSelectedSettings(item) {
    this.selectedSetting = item;
  }
  onCancel() {
    this.dialogRef.close()
  }
  onChange(event, item, type: string) {
    const isChecked = event.checked;
    const bool = isChecked ? 1 : 0;
    if (type == 'mobile') {
      item.mobile = bool;
    }
    else {
      item.email = bool;
    }
  }
  transformObject(array: any[], keyName) {
    const selectedSett = array.find((item) => item.key_name == keyName);
    const transformObject = { ...selectedSett };
    delete transformObject["name"];
    delete transformObject["key_name"];
    delete transformObject["type"];
    if (!transformObject.hasOwnProperty('value') && (transformObject["selected"] == true)) {
      transformObject["value"] = "2";
    }
    return transformObject;
  }
  onSubmit() {
    let obj = {}
    obj["r_type"] = '1'
    obj["u_t"] = '1'
    obj["u_id"] = []
    if (this.generalObj.enable_unavailability.selected == true) {
      obj["enable_unavailability"] = { "selected": true }
      if (this.generalObj.unavailability_val && this.generalObj.unavailability_val == "unavailability") {
        obj["user_mark_unavailability"] = { "yes_no": "1", "selected": true }
        obj["user_mark_prefer_unavailability"] = { "yes_no": "0", "selected": false }
      }
      if (this.generalObj.unavailability_val && this.generalObj.unavailability_val == "unavailability_prefer") {
        obj["user_mark_prefer_unavailability"] = { "yes_no": "1", "selected": true }
        obj["user_mark_unavailability"] = { "yes_no": "0", "selected": false }
      }
    } else {
      obj["enable_unavailability"] = { "selected": false }
    }

    if (this.generalObj.enable_shift_replacement.selected == true) {

      obj["enable_shift_replacement"] = { "selected": true }

      if (this.generalObj.shift_replacement.selected) {
        obj["shift_replacement"] = { "yes_no": "1", "app": "1", "selected": true }
      }
      else {
        obj["shift_replacement"] = { "yes_no": "0", "app": "", "selected": false }
      }
    } else {
      obj["enable_shift_replacement"] = { "selected": false }
    }
    if (this.generalObj.who_created_shift.selected) {
      obj["who_created_shift"] = { "yes_no": "1", "selected": true }
    } else {
      obj["who_created_shift"] = { "yes_no": "0", "selected": false }
    }
    if (this.generalObj.who_assign_shift.selected) {
      obj["who_assign_shift"] = { "yes_no": "1", "selected": true }
    } else {
      obj["who_assign_shift"] = { "yes_no": "0", "selected": false }
    }
    if (this.generalObj.who_publish_shift.selected) {
      obj["who_publish_shift"] = { "yes_no": "1", "selected": true }
    } else {
      obj["who_publish_shift"] = { "yes_no": "0", "selected": false }
    }

    for (let i = 0; i < this.userLimitationArr.length; i++) {
      // if (this.userLimitationArr[i]["selected"] == true) {
        obj[this.userLimitationArr[i]["key_name"]] = this.transformObject(this.userLimitationArr, this.userLimitationArr[i]["key_name"])
      // }
    }
    for (let i = 0; i < this.schedulerLimitationArr.length; i++) {
      // if (this.schedulerLimitationArr[i]["selected"] == true) {
        obj[this.schedulerLimitationArr[i]["key_name"]] = this.transformObject(this.schedulerLimitationArr, this.schedulerLimitationArr[i]["key_name"])
      // }
    }
    for (let i = 0; i < this.notificationArr.length; i++) {
      let newObj = {}
      newObj[this.notificationArr[i]["key_name"]] = {
        mobile: this.notificationArr[i]["mobile"],
        email: this.notificationArr[i]["email"],
      }
      if (this.notificationArr[i].hasOwnProperty('value')) {
        if (this.notificationArr[i]["value"] == "") {
          this.notificationArr[i]["value"] = "2";
        }
        newObj[this.notificationArr[i]["key_name"]]["value"] = this.notificationArr[i]["value"]
      }
      obj = Object.assign(obj, newObj)
    }
    this.onCallAPI(obj)
  }
  onCallAPI(obj) {
    this.rulesService.submitRules(obj).subscribe(({
      next: (success: any) => {
        if (success.status == 200) {
          this.appService.showToastMessage('success', success.msg);
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error)
      }
    }))
  }
  getSettings() {
    const obj = {
      "r_type": "1"
    }
    this.rulesService.getRules(obj).subscribe({
      next: (success: any) => {
        // this.spinner.hide();
        if (success.status == 200) {
          let data = success.msg;
          for (let [key, val] of Object.entries(data)) {
            if (key in this.generalObj) {
              this.generalObj[key] = val;

              if (this.generalObj["user_mark_unavailability"].selected) {
                this.generalObj.unavailability_val = "unavailability"
              } else {
                this.generalObj.unavailability_val = "unavailability_prefer"
              }
              if (val && typeof val === 'object' && 'selected' in val) {
                this.generalObj[key].selected = val.selected;
              }
            }
          }
          this.notificationArr.forEach(notification => {
            const keyName = notification.key_name;
            if (keyName in data) {
              notification.mobile = data[keyName].mobile;
              notification.email = data[keyName].email;
              notification.value = data[keyName].value;
            }
          });
          this.schedulerLimitationArr.forEach(sNotification => {
            const keyName = sNotification.key_name;
            if(keyName in data){
              sNotification.selected = data[keyName].selected;
              sNotification.value = data[keyName].value;
            }
          })

          this.userLimitationArr.forEach(uNotification => {
            const keyName = uNotification.key_name
            if(keyName in data){
              uNotification.selected = data[keyName].selected;
              uNotification.value = data[keyName].value;
              uNotification.hmd = (data[keyName].hmd ?? '').toString();
            }
          })
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      }
    })
  }
}